import { connect } from 'react-redux';
import { RootState, Dispatch } from 'shared/state';
import {
  addChild,
  updateWidgetConfig,
  selectWidget,
  setActiveWidgetId,
  selectPage,
  normalizeHeaderFooter,
} from 'shared/state/ducks/sites';
import { WidgetWrapper } from './WidgetWrapper';
import { initiateLogout } from 'shared/state/ducks/session';
import {
  setSelectedWidgetIds,
  clearSelectedWidgetIds,
} from 'shared/state/ducks/widgets';

interface WidgetWrapperContainerProps {
  siteId: number;
  pageId: number;
  site?: Site;
  page?: Page;
  widgetId: string;
  tracking?: any;
}

const mapStateToProps = (
  state: RootState,
  ownProps: WidgetWrapperContainerProps
) => ({
  widgetState: selectWidget(
    ownProps.siteId,
    ownProps.pageId,
    ownProps.widgetId
  )(state),
  activeWidgetId: state.sites.activeWidgetId,
  page: selectPage(ownProps.siteId, ownProps.pageId)(state),
});

const mapDispatchToProps = (
  dispatch: Dispatch,
  ownProps: WidgetWrapperContainerProps
) => ({
  initiateLogout: () => {
    dispatch(initiateLogout());
  },
  addChild: (type: string, initialConfig: any, location: number) => {
    dispatch(
      addChild(
        ownProps.siteId,
        ownProps.pageId,
        ownProps.widgetId,
        type,
        initialConfig,
        location
      )
    );
  },
  onUpdateConfig: (config: any) => {
    dispatch(
      updateWidgetConfig(
        ownProps.siteId,
        ownProps.pageId,
        ownProps.widgetId,
        config
      )
    );
  },
  setActiveWidgetId: (widgetId: string) => {
    dispatch(setActiveWidgetId(widgetId));
  },
  setSelectedWidgetIds: (widgetId: string) => {
    dispatch(setSelectedWidgetIds(widgetId));
  },
  clearSelectedWidgetIds: () => {
    dispatch(clearSelectedWidgetIds());
  },
  normalizeHeaderFooter: () => {
    dispatch(normalizeHeaderFooter(ownProps.siteId, ownProps.pageId));
  },
});

// Tracking now originates at SiteLandingPage; this container simply connects widget state.
export default connect(mapStateToProps, mapDispatchToProps)(WidgetWrapper);
